export function isDevOrStaging() {
  if (process.dev)
    return true;

  const url = window.location.href;
  const pattern = /grape-app-git-.+-grapelawfirm\.vercel\.app/;
  const isPRDeployment = pattern.test(url);
  return isPRDeployment;
};
